import { render, staticRenderFns } from "./prexc-classification.vue?vue&type=template&id=44ad0488&"
import script from "./prexc-classification.vue?vue&type=script&lang=js&"
export * from "./prexc-classification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports